import { render } from "./audiences-sessions.vue?vue&type=template&id=935e361c"
import script from "./audiences-sessions.vue?vue&type=script&lang=js"
export * from "./audiences-sessions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__